// Check if one JavaScript class inherits from another
export function inheritsFrom(Type, ParentType) {
  while (Type) {
    if (Type === ParentType) {
      return true;
    }

    Type = Object.getPrototypeOf(Type);
  }

  return false;
}
//# sourceMappingURL=inherits-from.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/react/dist/esm/utils/inherits-from.js
// module id = 435
// module chunks = 0